var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredSuccessVariant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Success",
    clipPath: "url(#clip0_1210_26881)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    opacity: 0.5,
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#DFE2EB"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 44,
    cy: 43.9997,
    r: 26.6316,
    fill: "white",
    stroke: "#00193C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6411 53.9914C43.4416 54.6235 41.8826 54.4263 40.9032 53.4396L33.7924 46.2754C32.6551 45.1295 32.7302 43.3528 33.9602 42.3071C35.1901 41.2613 37.1091 41.3424 38.2464 42.4882L42.7559 47.0316L50.8847 35.4003C51.8367 34.038 53.7618 33.6301 55.1845 34.4892C56.6072 35.3483 56.9888 37.149 56.0367 38.5113L45.976 52.907C45.6339 53.3966 45.1661 53.7629 44.6411 53.9914Z",
    fill: "#0E5CF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6411 53.9914L44.4016 53.4413L44.3811 53.4502L44.3614 53.4606L44.6411 53.9914ZM40.9032 53.4396L40.4773 53.8623L40.4773 53.8623L40.9032 53.4396ZM33.7924 46.2754L34.2183 45.8527L33.7924 46.2754ZM33.9602 42.3071L33.5715 41.85L33.5715 41.85L33.9602 42.3071ZM38.2464 42.4882L37.8206 42.9109L38.2464 42.4882ZM42.7559 47.0316L42.3301 47.4543L42.8362 47.9642L43.2477 47.3753L42.7559 47.0316ZM50.8847 35.4003L51.3765 35.744L51.3765 35.744L50.8847 35.4003ZM56.0367 38.5113L56.5285 38.855L56.0367 38.5113ZM45.976 52.907L45.4842 52.5633L45.976 52.907ZM44.3614 53.4606C43.385 53.9751 42.1145 53.8083 41.329 53.0169L40.4773 53.8623C41.6506 55.0444 43.4982 55.2719 44.9208 54.5222L44.3614 53.4606ZM41.329 53.0169L34.2183 45.8527L33.3666 46.698L40.4773 53.8623L41.329 53.0169ZM34.2183 45.8527C33.3272 44.9549 33.3852 43.5835 34.3488 42.7642L33.5715 41.85C32.0753 43.1222 31.983 45.3041 33.3666 46.698L34.2183 45.8527ZM34.3488 42.7642C35.34 41.9214 36.9041 41.9875 37.8206 42.9109L38.6723 42.0656C37.3141 40.6972 35.0403 40.6011 33.5715 41.85L34.3488 42.7642ZM37.8206 42.9109L42.3301 47.4543L43.1818 46.609L38.6723 42.0656L37.8206 42.9109ZM43.2477 47.3753L51.3765 35.744L50.3929 35.0566L42.2641 46.6879L43.2477 47.3753ZM51.3765 35.744C52.1476 34.6406 53.722 34.307 54.8744 35.0028L55.4947 33.9756C53.8016 32.9532 51.5258 33.4354 50.3929 35.0566L51.3765 35.744ZM54.8744 35.0028C55.9999 35.6825 56.2981 37.0898 55.5449 38.1676L56.5285 38.855C57.6794 37.2082 57.2145 35.0141 55.4947 33.9756L54.8744 35.0028ZM55.5449 38.1676L45.4842 52.5633L46.4678 53.2507L56.5285 38.855L55.5449 38.1676ZM45.4842 52.5633C45.2093 52.9567 44.8313 53.2542 44.4016 53.4413L44.8806 54.5416C45.5009 54.2715 46.0584 53.8365 46.4678 53.2507L45.4842 52.5633Z",
    fill: "#00193C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1210_26881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredSuccessVariant);
export default __webpack_public_path__ + "static/media/ic-colored-success-variant.efe4d61f035b9a11401567fadc101bf2.svg";
export { ForwardRef as ReactComponent };